<div class="text-white text-center pt-5">
  @if (accountingProvider()) {
    @if (statusSuccess()) {
      <h4 class="mt-4">Connection with {{ accountingProvider() }} established.</h4>

      <!-- loading while calculating redirect -->
      @if (isLoadingConnection()) {
        <app-loader
          loadingText="Please wait a moment while we are setting things up in your accounting software..."></app-loader>
      }

      <!-- no redirect took place-->
      @if (accountingConnectionError() && !isLoadingConnection()) {
        <h5 class="mt-4">However, the integration with {{ accountingProvider() }} has failed.</h5>
        <ng-container [ngTemplateOutlet]="errorState"></ng-container>
      }
    }

    @if (statusError()) {
      <h4 class="mt-4">Connection to {{ accountingProvider() }} has failed.</h4>
      @if (requestCancelled()) {
        <p>Request was cancelled.</p>
        <a
          routerLink="/accounting/integrations/"
          class="btn btn-primary">
          Go back to integrations
        </a>
      } @else {
        <ng-container [ngTemplateOutlet]="errorState"></ng-container>
      }
    }
  }

  <ng-template #errorState>
    <p class="my-4">
      Something went wrong with the integration. Please try again. <br />If the problem persists please contact our
      support team.
    </p>
    <p>
      <a
        routerLink="/help-desk"
        class="btn btn-outline-light me-2">
        Contact Support
      </a>
      <a
        routerLink="/accounting/integrations/"
        class="btn btn-primary">
        Go back to integrations
      </a>
    </p>
  </ng-template>
</div>
